import type { AnalyticsEvent } from '@/lib/analytics/capture';
import type { CompanionEdge } from '@/lib/companion/companion-activity';

type EventName = AnalyticsEvent['name'];

/**
 * Which product events the companion reacts to.
 *
 * Product analytics already marks the moments the product considers
 * meaningful, at the call sites that own them, so the companion reads that
 * stream rather than growing a producer beside each one. Keyed by event name,
 * so an event the companion has no opinion about is simply absent.
 *
 * Deliberately sparse: a companion that reacts to everything is noise. Most
 * of the analytics vocabulary belongs to growth questions, not to moments
 * worth a visible response.
 */
export const ANALYTICS_EDGE: Partial<Record<EventName, CompanionEdge>> = {
  entity_created: 'document.created',
  entity_deleted_remote: 'doc.deleted.remote',
  entity_access_denied: 'access.denied',
  assistant_run_finished: 'ai.finished',
  assistant_run_needs_approval: 'ai.needs-approval',
  tab_opened: 'tab.navigated',
  tab_closed: 'tab.navigated',
};
